export default __webpack_public_path__ + "static/media/icon-twitter.a2ff35d0.png";